import React from 'react';
import { history } from '../store/store';
import { Router } from 'react-router-dom';
import LayoutContainer from '../containers/layout/layoutContainer';
import ScrollToTop from '../components/scrollToTop/scrollToTop';
const MainRouter = props => {
    return (
        <Router history={history}>
            <ScrollToTop />
            <LayoutContainer />
        </Router>
    );
};

export default MainRouter;
